// ============================================================
// LandingPage.js — REDESIGNED (professional SaaS layout)
// ============================================================
// IMAGE MANIFEST — place these files in frontend/public/icons/
//  image1  → Hero phone mockup (WhatsApp + AI chat UI)
//  image2  → Client/partner logo 1
//  image3  → Client/partner logo 2
//  image4  → Client/partner logo 3
//  image5  → Client/partner logo 4
//  image6  → Accent banner photo (person using WhatsApp)
//  image7  → Feature image — AI Agent + Smart Media
//  image8  → Feature image — Flow Builder + Multi-language + Escalation
//  image9  → Feature image — Bulk Campaigns + Scheduled Messages
//  image10 → Feature image — OTP API for Developers
// (Small icon-cards below still use emoji — swap to <img> later if you want.)
// ============================================================

import Login from './Login';
import { useState, useEffect, useRef } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import API from '../services/api';
import '../styles/landing_page.css';


const ProfessionalIcon = ({
    name,
    size = 22,
    strokeWidth = 1.8,
    className = ''
}) => {

    const commonProps = {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: strokeWidth,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: className,
        "aria-hidden": "true"
    };

    const icons = {

        flow: (
            <svg {...commonProps}>
                <rect x="3" y="4" width="6" height="5" rx="1" />
                <rect x="15" y="15" width="6" height="5" rx="1" />
                <rect x="15" y="4" width="6" height="5" rx="1" />
                <path d="M9 6.5h4a2 2 0 0 1 2 2v6.5" />
                <path d="M15 17.5h-4a2 2 0 0 1-2-2V9" />
            </svg>
        ),

        ai: (
            <svg {...commonProps}>
                <rect x="6" y="6" width="12" height="12" rx="3" />
                <path d="M9 2v2M15 2v2M9 20v2M15 20v2" />
                <path d="M2 9h4M2 15h4M18 9h4M18 15h4" />
                <circle cx="10" cy="11" r="1" />
                <circle cx="14" cy="11" r="1" />
                <path d="M9 15c1.5 1 4.5 1 6 0" />
            </svg>
        ),

        link: (
            <svg {...commonProps}>
                <path d="M10 13a5 5 0 0 0 7.07.07l2-2a5 5 0 0 0-7.07-7.07l-1.15 1.15" />
                <path d="M14 11a5 5 0 0 0-7.07-.07l-2 2A5 5 0 0 0 12 20l1.15-1.15" />
            </svg>
        ),

        campaign: (
            <svg {...commonProps}>
                <path d="M3 11v2a2 2 0 0 0 2 2h2l2 5h2l-1.5-5H12l7 3V5l-7 3H5a2 2 0 0 0-2 2v1Z" />
                <path d="M19 8.5a4 4 0 0 1 0 7" />
            </svg>
        ),

        calendar: (
            <svg {...commonProps}>
                <rect x="3" y="4" width="18" height="17" rx="2" />
                <path d="M16 2v4M8 2v4M3 10h18" />
                <path d="M8 14h2M14 14h2M8 17h2" />
            </svg>
        ),

        media: (
            <svg {...commonProps}>
                <rect x="3" y="4" width="18" height="16" rx="2" />
                <circle cx="8.5" cy="9" r="1.5" />
                <path d="m4 17 5-5 3 3 2-2 6 6" />
            </svg>
        ),

        shield: (
            <svg {...commonProps}>
                <path d="M12 3 20 6v5c0 5-3.4 8.5-8 10-4.6-1.5-8-5-8-10V6l8-3Z" />
                <path d="m9 12 2 2 4-4" />
            </svg>
        ),

        globe: (
            <svg {...commonProps}>
                <circle cx="12" cy="12" r="9" />
                <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
            </svg>
        ),

        route: (
            <svg {...commonProps}>
                <circle cx="6" cy="5" r="2" />
                <circle cx="18" cy="19" r="2" />
                <path d="M8 5h4a3 3 0 0 1 3 3v1a3 3 0 0 0 3 3" />
                <path d="M18 12v5" />
            </svg>
        ),

        clock: (
            <svg {...commonProps}>
                <circle cx="12" cy="12" r="9" />
                <path d="M12 7v5l3 2" />
            </svg>
        ),

        chart: (
            <svg {...commonProps}>
                <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
            </svg>
        ),

        contacts: (
            <svg {...commonProps}>
                <circle cx="9" cy="8" r="3" />
                <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" />
                <circle cx="17" cy="9" r="2" />
                <path d="M17 14c2.2 0 4 1.8 4 4" />
            </svg>
        ),

        settings: (
            <svg {...commonProps}>
                <circle cx="12" cy="12" r="3" />
                <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1-1.8 1.8-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.5V20h-2.6v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.9.3l-.1.1-1.8-1.8.1-.1A1.7 1.7 0 0 0 8 15a1.7 1.7 0 0 0-1.5-1H6v-2.6h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.9l-.1-.1L9 6.6l.1.1a1.7 1.7 0 0 0 1.9.3 1.7 1.7 0 0 0 1-1.5V5h2.6v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.9-.3l.1-.1 1.8 1.8-.1.1a1.7 1.7 0 0 0-.3 1.9 1.7 1.7 0 0 0 1.5 1h.1V14h-.1a1.7 1.7 0 0 0-1.1 1Z" />
            </svg>
        ),

        support: (
            <svg {...commonProps}>
                <path d="M8 12a4 4 0 1 0 8 0" />
                <path d="M3 13a9 9 0 0 1 18 0" />
                <path d="M3 13v4a2 2 0 0 0 2 2h2v-6H3ZM21 13v4a2 2 0 0 1-2 2h-2v-6h4Z" />
            </svg>
        ),

        website: (
            <svg {...commonProps}>
                <circle cx="12" cy="12" r="9" />
                <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
            </svg>
        ),

        mail: (
            <svg {...commonProps}>
                <rect x="3" y="5" width="18" height="14" rx="2" />
                <path d="m3 7 9 6 9-6" />
            </svg>
        ),

        success: (
            <svg {...commonProps}>
                <circle cx="12" cy="12" r="9" />
                <path d="m8 12 2.5 2.5L16 9" />
            </svg>
        ),

        send: (
            <svg {...commonProps}>
                <path d="m21 3-7.5 18-3.5-7-7-3.5L21 3Z" />
                <path d="M10 14 21 3" />
            </svg>
        ),

        message: (
            <svg {...commonProps}>
                <path d="M20 11.5a8 8 0 0 1-8 7.5 8.8 8.8 0 0 1-3.5-.7L4 20l1.7-4.1A7.7 7.7 0 0 1 4 11.5a8 8 0 1 1 16 0Z" />
            </svg>
        )
    };

    return icons[name] || null;
};
function LandingPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const isAuthenticated = !!localStorage.getItem('token');
    // --- Hero Animation States ---
    const [chatStep, setChatStep] = useState(0);
    const [typedTitle, setTypedTitle] = useState('');
    const chatLoopRef = useRef(null);
    const heroTitleFull = "Reach Every\nBeneficiary\nInstantly";

    // Chat bubbles sequence loop
    // Chat sequence loop: User first -> Bot reply -> Buttons -> Reset
    // Chat sequence loop
    // Sequence 1: User -> Bot -> Time Buttons
    // Sequence 2: User Confirmation -> Bot Confirmation -> Appointment Confirmed
    useEffect(() => {
        const runSequence = () => {
            setChatStep(0);

            const steps = [
                [500, () => setChatStep(1)],   // User message
                [1300, () => setChatStep(2)],  // Bot reply
                [2100, () => setChatStep(3)],  // Time buttons

                [3300, () => setChatStep(4)],  // User: 2:00 PM works perfectly
                [4100, () => setChatStep(5)],  // Bot confirmation
                [4900, () => setChatStep(6)],  // Appointment Confirmed

                [6800, () => runSequence()]    // Restart
            ];

            chatLoopRef.current = steps.map(([delay, fn]) =>
                setTimeout(fn, delay)
            );
        };

        runSequence();

        return () => {
            chatLoopRef.current?.forEach(clearTimeout);
        };
    }, []);

    // Typewriter effect
    useEffect(() => {
        let i = 0;
        setTypedTitle('');
        const interval = setInterval(() => {
            i++;
            setTypedTitle(heroTitleFull.slice(0, i));
            if (i >= heroTitleFull.length) clearInterval(interval);
        }, 50);
        return () => clearInterval(interval);
    }, []);

    const [scrolled, setScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [loginModalOpen, setLoginModalOpen] = useState(false);

    const [contactOpen, setContactOpen] = useState(() => !localStorage.getItem('hasSeenContactPopup'));
    const [contactForm, setContactForm] = useState({ name: '', email: '', phone: '', useCase: '', message: '' });
    const [contactSent, setContactSent] = useState(false);
    const [contactSending, setContactSending] = useState(false);
    const [phoneError, setPhoneError] = useState('');

    const openFloat = () => openContact();

    const closeContactPopup = () => {
        setContactOpen(false);
        localStorage.setItem('hasSeenContactPopup', 'true');
    };

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        if (!localStorage.getItem('hasSeenContactPopup')) {
            localStorage.setItem('hasSeenContactPopup', 'true');
        }
    }, []);

    useEffect(() => {
        if (location.state?.openLogin) setLoginModalOpen(true);
        if (location.state?.openContact) setContactOpen(true);
    }, [location.state]);

    const validatePhone = (value) => {
        if (!value.trim()) return ''; // optional field
        const cleaned = value.replace(/[\s-]/g, '');
        const isIndian = /^(\+91|91|0)?[6-9]\d{9}$/.test(cleaned);
        const isInternational = /^\+(?!91)[1-9]\d{7,14}$/.test(cleaned);
        return isIndian || isInternational
            ? ''
            : 'Please enter a valid mobile number (e.g. +91 9876543210)';
    };

    const handleContactSubmit = async (e) => {
        e.preventDefault();
        const phoneMsg = validatePhone(contactForm.phone);
        if (phoneMsg) {
            setPhoneError(phoneMsg);
            return;
        }
        setContactSending(true);
        try {
            await API.post('/auth/contact', contactForm);
            setContactSent(true);
            toast.success('Inquiry submitted successfully!');
        } catch (err) {
            console.error('Submit contact inquiry error:', err);
            toast.error(err.response?.data?.message || 'Failed to send message. Please try again.');
        } finally {
            setContactSending(false);
        }
    };

    const openContact = () => {
        setContactSent(false);
        setContactForm({ name: '', email: '', phone: '', useCase: '', message: '' });
        setPhoneError('');
        setContactOpen(true);
    };
    // ---------- Content data ----------

    const heroBadges = [
        { icon: '🤖', label: 'AI Agent' },
        { icon: '🎨', label: 'Flow Builder' },
        { icon: '📢', label: 'Bulk Campaigns' }
    ];

    const audience = [
        {
            icon: 'ngo',
            title: 'NGOs & Nonprofits',
            description: 'Answer beneficiary queries, share program information and scheme eligibility instantly on WhatsApp.'
        },
        {
            icon: 'community',
            title: 'Health & Community Programs',
            description: 'Send vaccination reminders, health camp updates and support frontline and ASHA workers automatically.'
        },
        {
            icon: 'education',
            title: 'Education NGOs & Coaching Centers',
            description: 'Help with admissions, scholarship information and share study material without manual replies.'
        },
        {
            icon: 'business',
            title: 'Growing Businesses',
            description: 'Handle customer queries, bookings and support — the same platform works for you too.'
        }
    ];

    const comparePaths = [
        {
            title: 'DIY Self-Service',
            subtitle: 'Build and manage it yourself',
            points: [
                'Full access to the Visual Flow Builder',
                'Pre-built templates to start fast',
                'Documentation & tutorials included',
                'You manage your own OpenAI credits'
            ],
            bestFor: ['Startups', 'Agencies', 'Tech-savvy teams', 'NGOs with tech volunteers'],
            cta: 'Explore Self-Service'
        },
        {
            title: 'Full Turnkey Solution',
            subtitle: 'We build and manage it for you',
            points: [
                'Complete flow development by our team',
                'WhatsApp Business account setup handled',
                'Managed AI — no OpenAI account needed',
                'Dedicated account manager'
            ],
            bestFor: ['Enterprises', 'High-volume businesses', 'Non-technical teams', 'Large NGOs & Foundations', 'Government Programs'],
            cta: 'Explore Turnkey',
            highlighted: true
        }
    ];

    const zigzagFeatures = [
        {
            image: '/icons/image 11.png',

            title: "One AI Agent, Every Community Question",

            description:
                "Give beneficiaries instant answers about your NGO programs, government schemes, eligibility, documents and community services, directly on WhatsApp.",

            points: [
                'Answer beneficiary questions using your NGO\'s own information',
                'Automatically share PDFs, forms, guides and helpful resources',
                'Provide consistent support in Hindi, English and local languages'
            ]
        },
        {
            image: '/icons/flow-builder.png',
            title: "Flows That Speak Your Customer's Language",
            description: 'Build no-code conversation flows that detect Hindi or English automatically, and escalate to the right team member the moment a query gets complex.',
            points: [
                'Drag-and-drop Visual Flow Builder',
                'Auto-detects Hindi/English and replies accordingly',
                'Smart escalation routes queries to the right department'
            ]
        },
        {
            image: '/icons/image9.png',
            title: 'Reach Thousands, Right On Time',
            description: 'Upload an Excel sheet and send bulk campaigns in minutes, or schedule one-time and daily recurring messages so nothing is ever sent late.',
            points: [
                'Bulk campaigns from Excel/CSV with live status tracking',
                'One-time or daily recurring scheduled messages',
                'Failed-recipient resend and full Excel export'
            ]
        },
        {
            image: '/icons/image10.png',
            title: 'WhatsApp OTPs From Your Own System',
            description: 'A simple developer API lets your existing website or app send secure WhatsApp OTPs directly — no need to build WhatsApp integration yourself.',
            points: [
                'REST API with your own API key',
                'Delivery status callbacks to your server',
                'Built on the official WhatsApp Business API'
            ]
        }
    ];

    const allFeatures = [
        { icon: 'flow', title: 'Visual Flow Builder', description: 'Drag-and-drop interface to build conversation flows without writing code.' },
        { icon: 'ai', title: 'AI-Powered Responses', description: 'Context-aware replies trained only on your business data.' },
        { icon: 'link', title: 'Official WhatsApp Business API', description: 'Reliable, secure delivery with no risk of number bans.' },
        { icon: 'campaign', title: 'Bulk Campaigns', description: 'Send template or text campaigns to thousands of contacts at once.' },
        { icon: 'calendar', title: 'Scheduled Messages', description: 'One-time or daily recurring messages sent exactly on time.' },
        { icon: 'media', title: 'Smart Media Auto-Send', description: 'Automatically sends images, videos or documents based on keywords.' },
        { icon: 'shield', title: 'OTP Verification API', description: 'Send secure WhatsApp OTPs directly from your own systems.' },
        { icon: 'globe', title: 'Multi-Language Support', description: "Detects and replies in the customer's preferred language." },
        { icon: 'route', title: 'Smart Escalation', description: 'Routes complex queries to the right team automatically.' },
        { icon: 'clock', title: 'Time-Based Greetings', description: 'Greets customers differently through the day, automatically.' },
        { icon: 'chart', title: 'Real-Time Analytics', description: 'Track conversations and performance from one dashboard.' },
        { icon: 'contacts', title: 'Contact & Label Management', description: 'Organize contacts and segment them for targeted campaigns.' }
    ];

    const howItWorks = [
        {
            step: '1',
            title: 'Connect WhatsApp',
            description: 'Connect your WhatsApp Business number to ChatTech24.'
        },
        {
            step: '2',
            title: 'Configure Your AI',
            description: 'Set up your AI assistant, knowledge and conversation flow.'
        },
        {
            step: '3',
            title: 'Test Everything',
            description: 'Test messages, flows and automation before going live.'
        },
        {
            step: '4',
            title: 'Go Live',
            description: 'Start engaging customers automatically on WhatsApp.'
        }
    ];

    const whyChooseUs = [
    {
        icon: 'link',
        title: 'Built on Official WhatsApp API',
        text: 'Direct integration with WhatsApp Business API means reliable delivery and no risk of your number getting flagged or banned.'
    },
    {
        icon: 'settings',
        title: 'Everything in One Platform',
        text: "Flow builder, AI agent, bulk campaigns, scheduling and OTP API — you don't need five different tools to run your WhatsApp business."
    },
    {
        icon: 'support',
        title: 'You Choose How Much Help You Need',
        text: 'Go fully DIY, get guided setup, or let our team build and manage everything for you.'
    },
    {
        icon: 'shield',
        title: 'Built for Sensitive Data',
        text: 'Advanced beneficiary data privacy and secure handling, especially critical when working with vulnerable populations and sensitive records.'
    }
];
    const logos = [
        '/icons/Client_logo_1.png',
        '/icons/Client_logo_2.png',
        '/icons/Client_logo_3.png',
        '/icons/Client_logo_4.png'
    ];

    return (
        <div className="ct-landing">
            {/* NAVBAR */}
            <nav className={`ct-nav ${scrolled ? 'ct-nav-scrolled' : ''}`}>
                <div className="ct-nav-brand" onClick={() => navigate('/')}>
                    <img src="/logo.png" alt="ChatTech24" style={{ height: '40px', width: 'auto', objectFit: 'contain' }} />
                </div>
                <div className="ct-nav-links">
                    <Link to="/how-it-works" className="ct-nav-link">How It Works</Link>
                    <Link to="/features" className="ct-nav-link">Features</Link>
                    <Link to="/services" className="ct-nav-link">Services</Link>
                    <Link to="/pricing" className="ct-nav-link">Pricing</Link>
                    <Link to="/contact" className="ct-nav-link">Contact</Link>
                </div>
                <div className="ct-nav-actions">
                    {isAuthenticated ? (
                        <button onClick={() => navigate('/dashboard')} className="ct-btn-primary">Dashboard →</button>
                    ) : (
                        <>
                            <button onClick={() => setLoginModalOpen(true)} className="ct-btn-ghost">Login</button>
                            <button onClick={() => navigate('/pricing')} className="ct-btn-primary">Get Started</button>
                        </>
                    )}
                </div>
                <button className="ct-nav-hamburger" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                    <span /><span /><span />
                </button>
            </nav>

            {mobileMenuOpen && (
                <div className="ct-nav-mobile">
                    <div className="ct-mobile-menu-header">
                        <div className="ct-mobile-menu-brand" onClick={() => { navigate('/'); setMobileMenuOpen(false); }}>
                            <img src="/logo1.png" alt="ChatTech24" style={{ height: '34px' }} />
                            <span style={{ color: '#D3D3D3', fontFamily: 'Sora, sans-serif', fontSize: '12px', fontWeight: 700 }}>ChatTech24</span>
                        </div>
                        <button className="ct-mobile-menu-close" onClick={() => setMobileMenuOpen(false)}>✕</button>
                    </div>
                    <div className="ct-mobile-menu-links">
                        {[
                            ['/how-it-works', '⚙️', 'How It Works'],
                            ['/features', '✨', 'Features'],
                            ['/services', '🚀', 'Services'],
                            ['/pricing', '💎', 'Pricing'],
                            ['/contact', '📞', 'Contact']
                        ].map(([to, icon, label]) => (
                            <Link key={to} to={to} className="ct-mobile-link" onClick={() => setMobileMenuOpen(false)}>
                                <span className="ct-mobile-link-icon">{icon}</span>
                                <span>{label}</span>
                                <span className="ct-mobile-link-arrow">›</span>
                            </Link>
                        ))}
                    </div>
                    <div className="ct-mobile-menu-actions">
                        <button className="ct-mobile-btn-login" onClick={() => { setLoginModalOpen(true); setMobileMenuOpen(false); }}>👤 Login</button>
                        <button className="ct-mobile-btn-cta" onClick={() => { navigate('/pricing'); setMobileMenuOpen(false); }}>🚀 Get Started</button>
                    </div>
                </div>
            )}

            {/* HERO */}
            {/* HERO */}
            {/* HERO WITH SAWABOT STYLE FRAME */}
            <section className="ct-hero-section-wrapper">
                <div className="ct-hero-card-container">

                    {/* Inner Green Curved Frame */}
                    <div className="ct-hero-inner-frame">
                        <div className="ct-hero-v2-inner">

                            {/* Left Content */}
                            <div className="ct-hero-v2-content">
                                <h1 className="ct-hero-v2-title">
                                    {typedTitle}
                                    <span className="ct-typewriter-cursor">|</span>
                                </h1>
                                <p className="ct-hero-v2-subtitle">
                                    AI Assistants That Answer customers, beneficiaries, volunteers and staff Automatically — Directly On WhatsApp.
                                </p>
                                <div className="ct-hero-ctas">
                                    <button onClick={openFloat} className="ct-btn-hero">Book A Demo</button>
                                    <button onClick={openFloat} className="ct-btn-hero-outline">See A WhatsApp Demo</button>
                                </div>
                            </div>

                            {/* Right Hand + Phone Mockup */}
                            <div className="ct-hero-v2-media">
                                <div className="ct-mockup-wrapper">
                                    <img src="/icons/image1.png" alt="ChatTech24 AI on WhatsApp" className="ct-hero-v2-img" />

                                    {/* 1. User Message (Pehle aayega) */}
                                    {chatStep >= 1 && chatStep <= 3 && (
                                        <div className="ct-float-bubble ct-float-user ct-bubble-fade-in">
                                            <p>Hello, I'd like to schedule an appointment for tomorrow</p>
                                        </div>
                                    )}

                                    {/* 2. Bot Message (User ke baad) */}
                                    {chatStep >= 2 && chatStep <= 3 && (
                                        <div className="ct-float-bubble ct-float-bot ct-bubble-fade-in">
                                            <p>Here are tomorrow's available times. Which works best for you?</p>
                                        </div>
                                    )}

                                    {/* 3. Bot Option Buttons */}
                                    {chatStep === 3 && (
                                        <div className="ct-float-actions ct-bubble-fade-in">
                                            <button type="button" className="ct-float-pill">10:00 AM</button>
                                            <button type="button" className="ct-float-pill ct-pill-active">02:00 PM</button>
                                            <button type="button" className="ct-float-pill">03:30 PM</button>
                                        </div>
                                    )}
                                    {/* 4. User confirms selected time */}
                                    {chatStep >= 4 && (
                                        <div className="ct-float-bubble ct-float-confirm-user ct-bubble-fade-in">
                                            <p>2:00 PM works perfectly!</p>
                                        </div>
                                    )}

                                    {/* 5. Bot confirms appointment */}
                                    {chatStep >= 5 && (
                                        <div className="ct-float-bubble ct-float-confirm-bot ct-bubble-fade-in">
                                            <p>Perfect! Your appointment is confirmed for tomorrow at 2:00 PM.</p>
                                        </div>
                                    )}

                                    {/* 6. Appointment Confirmed card inside phone */}
                                    {chatStep >= 6 && (
                                        <div className="ct-appointment-confirmed ct-bubble-fade-in">
                                            <div className="ct-confirmed-icon">✓</div>
                                            <div className="ct-confirmed-title">Appointment</div>
                                            <div className="ct-confirmed-title">Confirmed</div>
                                        </div>
                                    )}
                                </div>
                            </div>

                        </div>


                        {/* Bottom Cutout & 3 Mini Cards (Template matching) */}
                        <div className="ct-hero-bottom-cutout">
                            <div className="ct-mini-card">
                                <span className="ct-mini-icon">
                                    <svg viewBox="0 0 24 24" aria-hidden="true">
                                        <rect x="3" y="5" width="18" height="16" rx="2" />
                                        <path d="M16 3v4M8 3v4M3 10h18" />
                                        <path d="M8 14h2M14 14h2M8 17h2" />
                                    </svg>
                                </span>
                                <div>
                                    <strong>Booking</strong>
                                    <span>Agent</span>
                                </div>
                            </div>
                            <div className="ct-mini-card">
                                <span className="ct-mini-icon">
                                    <svg viewBox="0 0 24 24" aria-hidden="true">
                                        <path d="M20 11.5a7.5 7.5 0 0 1-7.5 7.5H8l-4 2 1.2-3.6A7.5 7.5 0 1 1 20 11.5Z" />
                                        <path d="M8 11.5h8M8 15h5" />
                                    </svg>
                                </span>
                                <div>
                                    <strong>Support</strong>
                                    <span>Agent</span>
                                </div>
                            </div>
                            <div className="ct-mini-card">
                                <span className="ct-mini-icon">
                                    <svg viewBox="0 0 24 24" aria-hidden="true">
                                        <circle cx="12" cy="12" r="8" />
                                        <circle cx="12" cy="12" r="4" />
                                        <circle cx="12" cy="12" r="1.5" />
                                    </svg>
                                </span>
                                <div>
                                    <strong>Lead Capture</strong>
                                    <span>Agent</span>
                                </div>
                            </div>
                        </div>

                    </div>
                    {/* Background decorative ribbon */}
                    <div className="ct-hero-ribbon-wrap">
                        <svg
                            className="ct-hero-ribbon"
                            viewBox="0 0 1000 700"
                            preserveAspectRatio="none"
                            aria-hidden="true"
                        >
                            <path
                                d="M 390 700
           C 470 570, 570 520, 690 510
           C 790 500, 820 450, 850 360
           C 885 260, 925 220, 1000 210"
                                fill="none"
                                stroke="#61E6C1"
                                strokeWidth="5"
                                strokeLinecap="round"
                            />
                        </svg>
                    </div>
                </div>
            </section>

            {/* AUDIENCE */}
            <section className="ct-section">
                <div className="ct-container">
                    <div className="ct-section-header">
                        <div className="ct-section-tag">Who It's For</div>
                        <h2 className="ct-section-title">Built for NGOs, community programs and growing businesses</h2>
                        <p className="ct-section-subtitle">Whether you serve beneficiaries or customers, ChatTech24 fits right in.</p>
                    </div>
                    <div className="ct-audience-grid">
                        {audience.map((a, i) => (
                            <div key={i} className="ct-audience-card">
                                <div className="ct-audience-icon">

                                    {a.icon === 'ngo' && (
                                        <svg viewBox="0 0 24 24" aria-hidden="true">
                                            <path d="M12 21s-7-4.35-9.5-9A5.5 5.5 0 0 1 12 6a5.5 5.5 0 0 1 9.5 6c-2.5 4.65-9.5 9-9.5 9Z" />
                                        </svg>
                                    )}

                                    {a.icon === 'community' && (
                                        <svg viewBox="0 0 24 24" aria-hidden="true">
                                            <rect x="3" y="4" width="18" height="16" rx="2" />
                                            <path d="M8 9h8M12 6v6M9 15h6" />
                                        </svg>
                                    )}

                                    {a.icon === 'education' && (
                                        <svg viewBox="0 0 24 24" aria-hidden="true">
                                            <path d="m3 9 9-5 9 5-9 5-9-5Z" />
                                            <path d="M7 11.5v4c2.8 2 7.2 2 10 0v-4" />
                                            <path d="M21 9v6" />
                                        </svg>
                                    )}

                                    {a.icon === 'business' && (
                                        <svg viewBox="0 0 24 24" aria-hidden="true">
                                            <rect x="3" y="7" width="18" height="13" rx="2" />
                                            <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                                            <path d="M3 12h18" />
                                        </svg>
                                    )}

                                </div>
                                <h3 className="ct-audience-title">{a.title}</h3>
                                <p className="ct-audience-desc">{a.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* COMPARE PATHS */}
            <section className="ct-section ct-section-gray">
                <div className="ct-container">
                    <div className="ct-section-header">
                        <div className="ct-section-tag">Two Ways To Get Started</div>
                        <h2 className="ct-section-title">ChatTech24 adapts to how much help you want</h2>
                        <p className="ct-section-subtitle">Build it yourself, or let our team handle everything — including a guided setup in between.</p>
                    </div>
                    <div className="ct-compare-grid">
                        {comparePaths.map((p, i) => (
                            <div key={i} className={`ct-compare-card ${p.highlighted ? 'ct-compare-card-highlight' : ''}`}>
                                <h3 className="ct-compare-title">{p.title}</h3>
                                <p className="ct-compare-subtitle">{p.subtitle}</p>
                                <ul className="ct-compare-list">
                                    {p.points.map((pt, idx) => (
                                        <li key={idx}><span className="ct-path-check">✓</span>{pt}</li>
                                    ))}
                                </ul>
                                <div className="ct-compare-bestfor-label">Best for</div>
                                <div className="ct-compare-tags">
                                    {p.bestFor.map((t, idx) => <span key={idx} className="ct-compare-tag">{t}</span>)}
                                </div>
                                <button
                                    className="ct-btn-primary ct-compare-btn"
                                    onClick={() => navigate('/services')}
                                >
                                    {p.cta}
                                </button>
                            </div>
                        ))}
                    </div>
                    <p className="ct-compare-note">Need something in between? <button className="ct-compare-note-link" onClick={openFloat}>Talk to us about Guided Setup →</button></p>
                </div>
            </section>

            {/* LOGO STRIP */}
            {/* LOGO STRIP */}
            {/* CLIENT LOGOS - MOVING MARQUEE */}
            <section className="ct-logos-strip">
                <div className="ct-logo-marquee">
                    <div className="ct-logo-track">

                        {/* First set */}
                        {logos.map((logo, index) => (
                            <div className="ct-logo-box" key={`logo-1-${index}`}>
                                <img
                                    src={logo}
                                    alt="Client logo"
                                    className="ct-logo-item"
                                />
                            </div>
                        ))}

                        {/* Duplicate set for seamless infinite animation */}
                        {logos.map((logo, index) => (
                            <div className="ct-logo-box" key={`logo-2-${index}`}>
                                <img
                                    src={logo}
                                    alt="Client logo"
                                    className="ct-logo-item"
                                />
                            </div>
                        ))}

                    </div>
                </div>
            </section>

            {/* ACCENT BANNER */}
            {/* ACCENT BANNER */}
            <section className="ct-accent-banner">
                <div className="ct-accent-banner-inner">

                    {/* Left Content */}
                    <div className="ct-accent-banner-text">
                        <h2>
                            No New App.<br />
                            No Complex Software.<br />
                            Just WhatsApp<br />
                            With AI Behind It.
                        </h2>

                        <button
                            className="ct-accent-banner-btn"
                            onClick={() => navigate('/how-it-works')}
                        >
                            LEARN MORE
                        </button>
                    </div>

                    {/* Right Woman */}
                    <div className="ct-accent-banner-woman">
                        <img
                            src="/icons/image 2.png"
                            alt="Using ChatTech24 on WhatsApp"
                        />
                    </div>

                    {/* WhatsApp Icon */}
                    <div className="ct-accent-whatsapp">
                        <svg
                            viewBox="0 0 32 32"
                            aria-hidden="true"
                        >
                            <path
                                d="M16 3.5C9.1 3.5 3.5 9.1 3.5 16c0 2.3.6 4.5 1.8 6.4L3.5 28.5l6.3-1.7c1.9 1.1 4 1.7 6.2 1.7 6.9 0 12.5-5.6 12.5-12.5S22.9 3.5 16 3.5Z"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                            />
                            <path
                                d="M11.4 9.9c.4-.2.8-.1 1 .3l1.3 2.7c.2.4.1.8-.2 1.1l-.9.8c.8 1.6 2.1 2.9 3.7 3.7l.8-.9c.3-.3.7-.4 1.1-.2l2.7 1.3c.4.2.5.6.3 1-.5 1.1-1.5 1.8-2.7 1.8-4.8-.1-8.7-4-8.8-8.8 0-1.2.7-2.3 1.7-2.8Z"
                                fill="currentColor"
                            />
                        </svg>
                    </div>

                </div>
            </section>
            {/* ZIGZAG FEATURES */}
            <section className="ct-section">
                <div className="ct-container">
                    <div className="ct-section-header">
                        <div className="ct-section-tag">Discover Our Features</div>
                        <h2 className="ct-section-title">What ChatTech24 helps you do</h2>
                    </div>
                    {zigzagFeatures.map((f, i) => (
                        <div key={i} className={`ct-zigzag-row ${i % 2 === 1 ? 'ct-zigzag-reverse' : ''}`}>
                            <div className="ct-zigzag-media">
                                <img src={f.image} alt={f.title} />
                            </div>
                            <div className="ct-zigzag-content">
                                <h3>{f.title}</h3>
                                <p>{f.description}</p>
                                <ul className="ct-zigzag-pill-list">
                                    {f.points.map((pt, idx) => (
                                        <li key={idx} className="ct-zigzag-pill-item">
                                            <span className="ct-path-check">✓</span>
                                            <span>{pt}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* HOW IT WORKS — REFERENCE TEMPLATE STYLE */}
            <section className="ct-howworks-section">
                <div className="ct-howworks-card">

                    {/* Header */}
                    <div className="ct-howworks-header">
                        <h2>How it works ?</h2>
                    </div>

                    {/* Steps Grid */}
                    <div className="ct-howworks-steps">
                        <div className="ct-howworks-step">
                            <div className="ct-howworks-circle">1</div>
                            <h3>Connect a WhatsApp number</h3>
                            <p>Connect your WhatsApp Business number to ChatTech24.</p>
                        </div>
                        <div className="ct-howworks-step">
                            <div className="ct-howworks-circle">2</div>
                            <h3>Configure your AI assistant</h3>
                            <p>Set up your AI assistant, knowledge and conversation flow.</p>
                        </div>
                        <div className="ct-howworks-step">
                            <div className="ct-howworks-circle">3</div>
                            <h3>Test Everything</h3>
                            <p>Test messages, flows and automation before going live.</p>
                        </div>
                        <div className="ct-howworks-step">
                            <div className="ct-howworks-circle">4</div>
                            <h3>Go Live</h3>
                            <p>Start engaging customers automatically on WhatsApp.</p>
                        </div>
                    </div>

                    {/* Bottom Benefits */}
                    <div className="ct-howworks-benefits">
                        <div className="ct-howworks-benefit">
                            <span>✓</span>
                            <p>Launch your WhatsApp automation without complex setup.</p>
                        </div>
                        <div className="ct-howworks-benefit">
                            <span>✓</span>
                            <p>Manage your AI, flows and conversations from one dashboard.</p>
                        </div>
                    </div>

                    {/* Learn More Button */}
                    {/* Learn More Button */}
                    <button
                        className="ct-howworks-btn"
                        onClick={() => navigate('/how-it-works')}
                    >
                        LEARN MORE
                    </button>

                </div>
            </section>

            {/* FULL FEATURE GRID */}
            <section className="ct-section ct-section-gray">
                <div className="ct-container">
                    <div className="ct-section-header">
                        <div className="ct-section-tag">Everything Included</div>
                        <h2 className="ct-section-title">A complete WhatsApp automation toolkit</h2>
                    </div>
                    <div className="ct-features-grid">
                        {allFeatures.map((f, i) => (
                            <div key={i} className="ct-feature-card">
                                <div className="ct-feature-icon">
                                    <ProfessionalIcon name={f.icon} size={24} />
                                </div>
                                <h3 className="ct-feature-title">{f.title}</h3>
                                <p className="ct-feature-desc">{f.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* WHY CHOOSE US */}
            <section className="ct-section">
                <div className="ct-container">
                    <div className="ct-section-header">
                        <div className="ct-section-tag">Why Choose Us</div>
                        <h2 className="ct-section-title">Built for businesses like yours</h2>
                    </div>
                    <div className="ct-testimonials-grid">
                        {whyChooseUs.map((w, i) => (
                            <div key={i} className="ct-testimonial-card">
                                <div className="ct-testimonial-avatar avatar-gradient-primary">
                                    <ProfessionalIcon name={w.icon} size={22} />
                                </div>
                                <h3 style={{ fontSize: '17px', fontWeight: 700, color: 'var(--text-dark)', marginBottom: '10px' }}>{w.title}</h3>
                                <p className="ct-testimonial-text" style={{ fontStyle: 'normal' }}>{w.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section className="ct-cta-section">
                <div className="ct-cta-template">

                    {/* LEFT GREEN CONTENT CARD */}
                    <div className="ct-cta-green-card">

                        <div className="ct-cta-content">

                            <h2 className="ct-cta-title">
                                Ready to automate your<br />
                                WhatsApp communication?
                            </h2>

                            <p className="ct-cta-sub">
                                Start automating your WhatsApp conversations today — no credit card required
                            </p>

                            <div className="ct-cta-btns">

                                <button
                                    onClick={() => navigate('/pricing')}
                                    className="ct-btn-cta-white"
                                >
                                    🚀 Start Free Trial
                                </button>

                                <button
                                    onClick={openFloat}
                                    className="ct-btn-cta-outline"
                                >
                                    📞 Contact Sales
                                </button>

                            </div>

                            <p className="ct-cta-note">
                                No credit card required • 14-day free trial • Cancel anytime
                            </p>

                        </div>

                    </div>


                    {/* RIGHT VISUAL AREA */}
                    {/* RIGHT VISUAL AREA */}
                    <div className="ct-cta-visual">

                        {/* SINGLE NGO / WHATSAPP VISUAL */}
                        <img
                            className="ct-cta-main-visual"
                            src="/icons/image_A.png"
                            alt="WhatsApp communication for NGOs"
                        />



                    </div>

                </div>
            </section>

            {/* FOOTER */}
            <footer className="ct-footer">
                <div className="ct-container">

                    <div className="ct-footer-grid">

                        {/* BRAND / ABOUT */}
                        <div className="ct-footer-brand-section">

                            <div
                                className="ct-nav-brand ct-footer-brand"
                                onClick={() => navigate('/')}
                            >
                                <img
                                    src="/logo 1.png"
                                    alt="ChatTech24"
                                    className="ct-footer-logo"
                                />

                                <span className="ct-footer-brand-name">
                                    Chat Tech 24
                                </span>
                            </div>

                            <p className="ct-footer-tagline">
                                AI-powered WhatsApp automation platform for modern businesses.
                                Build, automate, and scale your customer conversations.
                            </p>

                            <div className="ct-footer-social">

                                <a
                                    href="https://vedvika.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="ct-footer-social-link"
                                >
                                    <ProfessionalIcon name="website" size={16} />
                                    Website
                                </a>

                                <button
                                    onClick={openFloat}
                                    className="ct-footer-social-link"
                                    type="button"
                                >
                                    <ProfessionalIcon name="mail" size={16} />
                                    Contact
                                </button>

                            </div>
                        </div>


                        {/* PRODUCT */}
                        <div className="ct-footer-col">

                            <div className="ct-footer-col-title">
                                Product
                            </div>

                            <Link to="/pricing">
                                Pricing
                            </Link>

                            <a href="#features">
                                Features
                            </a>

                            <Link to="/how-it-works">
                                How It Works
                            </Link>

                        </div>


                        {/* COMPANY */}
                        <div className="ct-footer-col">

                            <div className="ct-footer-col-title">
                                Company
                            </div>

                            <a
                                href="https://vedvika.com/#about"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                About Vedvika
                            </a>

                            <a
                                href="https://vedvika.com/contact"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Contact Us
                            </a>

                            <button
                                type="button"
                                onClick={openFloat}
                            >
                                Get a Demo
                            </button>

                        </div>


                        {/* SUPPORT */}
                        <div className="ct-footer-col">

                            <div className="ct-footer-col-title">
                                Support
                            </div>

                            <a href="#how-it-works">
                                Documentation
                            </a>

                            <button
                                type="button"
                                onClick={openFloat}
                            >
                                Talk to Sales
                            </button>

                            <a href="mailto:support@chattech24.com">
                                Email Support
                            </a>

                        </div>

                    </div>


                    {/* FOOTER BOTTOM */}
                    <div className="ct-footer-bottom">

                        <p className="ct-footer-copy">
                            © 2026 ChatTech24 by{" "}
                            <a
                                href="https://vedvika.com"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Vedvika Technologies
                            </a>
                            . All rights reserved.
                        </p>

                        <div className="ct-footer-legal">

                            <a
                                href="https://vedvika.com/privacy"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Privacy Policy
                            </a>

                            <Link to="/terms-and-conditions">
                                Terms & Conditions
                            </Link>

                        </div>

                    </div>

                </div>
            </footer>

            {/* CONTACT POPUP */}
            {contactOpen && (
                <div className="ct-popup-overlay" onClick={(e) => e.target === e.currentTarget && closeContactPopup()}>
                    <div className="ct-popup">
                        <div className="ct-popup-header">
                            <div className="ct-popup-header-left">
                                <div className="ct-popup-header-icon"><img src="/logo 1.png" alt="logo" style={{ width: '30px', height: '30px' }} /></div>
                                <div>
                                    <p className="ct-popup-header-title">Get in Touch</p>
                                    <p className="ct-popup-header-sub">We'll reply within 24 hours</p>
                                </div>
                            </div>
                            <button className="ct-popup-close" onClick={closeContactPopup}>✕</button>
                        </div>
                        {contactSent ? (
                            <div className="ct-popup-success">
                                <div className="ct-popup-success-icon">
                                    <ProfessionalIcon name="success" size={30} strokeWidth={1.8} />
                                </div>
                                <h3 className="ct-popup-success-title">Message Sent!</h3>
                                <p className="ct-popup-success-text">Thank you for reaching out! Our team will get back to you within 24 hours at <strong>{contactForm.email}</strong>.</p>
                            </div>
                        ) : (
                            <form className="ct-popup-body" onSubmit={handleContactSubmit}>
                                <div className="ct-popup-row">
                                    <div className="ct-popup-field">
                                        <label className="ct-popup-label">Your Name *</label>
                                        <input type="text" className="ct-popup-input" placeholder="Rahul Sharma" value={contactForm.name} onChange={e => setContactForm({ ...contactForm, name: e.target.value })} required />
                                    </div>
                                    <div className="ct-popup-field">
                                        <label className="ct-popup-label">Email *</label>
                                        <input type="email" className="ct-popup-input" placeholder="you@example.com" value={contactForm.email} onChange={e => setContactForm({ ...contactForm, email: e.target.value })} required />
                                    </div>
                                </div>
                                <div className="ct-popup-row">
                                    <div className="ct-popup-field">
                                        <label className="ct-popup-label">Phone Number</label>
                                        <input
                                            type="tel"
                                            inputMode="tel"
                                            maxLength={16}
                                            className={`ct-popup-input ${phoneError ? 'ct-popup-input-error' : ''}`}
                                            placeholder="+91 9876543210"
                                            value={contactForm.phone}
                                            onChange={e => {
                                                const value = e.target.value.replace(/[^\d+\s-]/g, '');
                                                setContactForm({ ...contactForm, phone: value });
                                                if (phoneError) setPhoneError('');
                                            }}
                                            onBlur={() => setPhoneError(validatePhone(contactForm.phone))}
                                        />
                                        {phoneError && <span className="ct-popup-error">{phoneError}</span>}                                    </div>
                                    <div className="ct-popup-field">
                                        <label className="ct-popup-label">Use Case</label>
                                        <select className="ct-popup-select" value={contactForm.useCase} onChange={e => setContactForm({ ...contactForm, useCase: e.target.value })}>
                                            <option value="">Select...</option>
                                            <option>Customer Support</option>
                                            <option>Sales & Marketing</option>
                                            <option>Appointment Booking</option>
                                            <option>Order Updates</option>
                                            <option>Lead Generation</option>
                                            <option>Other</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="ct-popup-field">
                                    <label className="ct-popup-label">Message *</label>
                                    <textarea className="ct-popup-textarea" placeholder="Tell us about your business and what you're looking to automate..." value={contactForm.message} onChange={e => setContactForm({ ...contactForm, message: e.target.value })} required />
                                </div>
                                <button
                                    type="submit"
                                    className="ct-popup-submit"
                                    disabled={contactSending}
                                >
                                    {contactSending ? (
                                        <>
                                            <span className="ct-spinner"></span>
                                            Sending...
                                        </>
                                    ) : (
                                        <>
                                            <ProfessionalIcon name="send" size={17} />
                                            Send Message
                                        </>
                                    )}
                                </button>                            </form>
                        )}
                    </div>
                </div>
            )}

            <Login isOpen={loginModalOpen} onClose={() => setLoginModalOpen(false)} />

            <div className="ct-float-btn">
                <button
                    className="ct-float-trigger"
                    onClick={openContact}
                    title="Contact Us"
                >
                    <span className="ct-float-label">Contact Us</span>
                    <ProfessionalIcon name="message" size={24} />
                </button>
            </div>
        </div>
    );
}

export default LandingPage;